(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nundies-button"] && !Shopify.designMode) return;
  try {
    /* ================= existing: mobile scroll-reveal for the arrow ========= */
  var mobileQuery = window.matchMedia('(max-width: 749px), (any-pointer: coarse)');
  var arrowObserver = null;
  var observedButtons = new WeakSet();

  function arrowButtonsWithin(root) {
    var buttons = [];
    if (root instanceof Element && root.matches('[data-nundies-arrow-scroll]')) buttons.push(root);
    if (root && typeof root.querySelectorAll === 'function') {
      buttons = buttons.concat(Array.prototype.slice.call(root.querySelectorAll('[data-nundies-arrow-scroll]')));
    }
    return buttons;
  }

  function scanArrowButtons(root) {
    arrowButtonsWithin(root || document).forEach(function (button) {
      if (!mobileQuery.matches) {
        button.classList.remove('is-arrow-visible');
        return;
      }
      if (observedButtons.has(button)) return;
      observedButtons.add(button);
      if (arrowObserver) {
        arrowObserver.observe(button);
      } else {
        button.classList.add('is-arrow-visible');
      }
    });
  }

  function configureArrowObserver() {
    if (arrowObserver) arrowObserver.disconnect();
    arrowObserver = null;
    observedButtons = new WeakSet();

    if (!mobileQuery.matches) {
      arrowButtonsWithin(document).forEach(function (button) {
        button.classList.remove('is-arrow-visible');
      });
      return;
    }

    if ('IntersectionObserver' in window) {
      arrowObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-arrow-visible', entry.isIntersecting);
          });
        },
        {
          rootMargin: '-15% 0px -50% 0px',
          threshold: 0,
        }
      );
    }

    scanArrowButtons(document);
  }

  /* ================= new: redraw the pill to fit the button ============== */
  /* The artwork is 834.85 x 218.79 units. Its two long edges are relative
     curves, so making the button wider only means lengthening those two
     runs — the drawn end caps are copied through untouched. That is why the
     caps never go oval, however long the label is. */
  var PILL_BASE_W = 834.85;
  var PILL_BASE_H = 218.79;
  var PILL_X0 = 61.93;
  var PILL_Y0 = 399.6;
  var PILL_PAD = 3;
  var PILL_TOP_RUN = 631.29;
  var PILL_BOT_RUN = 612.45;
  var PILL_MIN_DELTA = -520;

  var pillSizes = new WeakMap();
  var pillResizeObserver = null;
  var pillFrame = 0;
  var pillDirty = [];

  function nundiesPillPath(delta) {
    var top = PILL_TOP_RUN + delta;
    var kt = top / PILL_TOP_RUN;
    var bot = PILL_BOT_RUN + delta;
    var kb = bot / PILL_BOT_RUN;
    return 'M155.13,399.87' +
      ' c' + (210.68 * kt).toFixed(2) + ',-0.93 ' + (420.61 * kt).toFixed(2) + ',0.89 ' + top.toFixed(2) + ',-0.05' +
      ' c40.8,-0.18 78.82,23.69 98.04,59.67' +
      ' c19.23,35.98 16,84.89 -10,116.33' +
      ' c-26.13,31.62 -62.89,42.71 -103.91,42.57' +
      ' c' + (-200.15 * kb).toFixed(2) + ',-0.71 ' + (-412.3 * kb).toFixed(2) + ',-0.41 ' + (-bot).toFixed(2) + ',-1.12' +
      ' c-54.31,-0.19 -92.76,-51.42 -96,-105.64' +
      ' c-3.16,-52.92 38.6,-101.75 91.58,-111.33 Z';
  }

  function layoutPill(reveal) {
    var rect = reveal.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var vbH = PILL_BASE_H + PILL_PAD * 2;
    var delta = Math.max(PILL_MIN_DELTA, (rect.width / rect.height) * vbH - PILL_BASE_W - PILL_PAD * 2);
    var d = nundiesPillPath(delta);
    var viewBox = (PILL_X0 - PILL_PAD) + ' ' + (PILL_Y0 - PILL_PAD) + ' ' +
      (PILL_BASE_W + delta + PILL_PAD * 2) + ' ' + vbH;

    var svgs = reveal.querySelectorAll('.nundies-button__pill-svg');
    for (var i = 0; i < svgs.length; i++) svgs[i].setAttribute('viewBox', viewBox);

    var paths = reveal.querySelectorAll('[data-pill-path]');
    for (var j = 0; j < paths.length; j++) paths[j].setAttribute('d', d);

    // Right-cap highlights ride with the right cap in SVG user units
    var anchors = reveal.querySelectorAll('.nundies-button__gloss-anchor');
    var anchorTransform = 'translate(' + delta.toFixed(2) + ' 0)';
    for (var k = 0; k < anchors.length; k++) anchors[k].setAttribute('transform', anchorTransform);

    // the button changing width IS the shape change, so drive the gloss
    // reaction off it — covers hover, focus, the mobile scroll reveal and
    // label edits in the theme editor without any extra listeners
    var last = pillSizes.get(reveal);
    pillSizes.set(reveal, rect.width);
    if (last !== undefined && Math.abs(last - rect.width) > 1 && !reveal.classList.contains('is-shifting')) {
      reveal.classList.add('is-shifting');
      window.setTimeout(function () { reveal.classList.remove('is-shifting'); }, 820);
    }
  }

  function flushPills() {
    var list = pillDirty;
    pillDirty = [];
    list.forEach(layoutPill);
  }

  function schedulePill(reveal) {
    if (pillDirty.indexOf(reveal) === -1) pillDirty.push(reveal);
    window.cancelAnimationFrame(pillFrame);
    pillFrame = window.requestAnimationFrame(flushPills);
  }

  function scanPills(root) {
    var scope = root || document;
    var pills = [];
    if (scope instanceof Element && scope.matches('[data-nundies-pill]')) pills.push(scope);
    if (scope && typeof scope.querySelectorAll === 'function') {
      pills = pills.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-nundies-pill]')));
    }
    pills.forEach(function (reveal) {
      layoutPill(reveal);
      if (pillResizeObserver) pillResizeObserver.observe(reveal);
    });
  }

  if ('ResizeObserver' in window) {
    pillResizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) { schedulePill(entry.target); });
    });
  } else {
    window.addEventListener('resize', function () { scanPills(document); });
  }

  /* ================= wiring ============================================= */
  mobileQuery.addEventListener('change', configureArrowObserver);

  document.addEventListener('shopify:section:load', function (event) {
    scanArrowButtons(event.target || document);
    scanPills(event.target || document);
  });

  document.addEventListener('theme:dynamic-content', function (event) {
    var scope = event.detail && event.detail.scope ? event.detail.scope : document;
    scanArrowButtons(scope);
    scanPills(scope);
  });

  // theme editor: show the open state while the block is selected
  document.addEventListener('shopify:block:select', function (event) {
    var reveal = event.target && event.target.querySelector
      ? event.target.querySelector('.nundies-button-reveal') || event.target
      : null;
    if (reveal && reveal.classList) reveal.classList.add('is-arrow-visible');
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var reveal = event.target && event.target.querySelector
      ? event.target.querySelector('.nundies-button-reveal') || event.target
      : null;
    if (reveal && reveal.classList) reveal.classList.remove('is-arrow-visible');
  });

  configureArrowObserver();
  scanPills(document);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { scanPills(document); });
  }
  } catch(e) { console.error(e); }
})();

})();
